import { legacyApiAuth } from '@wiggot/apis/legacies-api/legacy-api'
import { IResponseService, IGenericObject } from '@/interfaces'
import { ISearchFilter } from '@/interfaces/search.interface'

interface IPersistKeyResponse {
  value: string | null
}

export interface IGetAssociationsResponse {
  associationId: number
  associationName: string
}

export const getSearchWelcome = async (): Promise<
  IResponseService<IPersistKeyResponse>
> => {
  const response = await legacyApiAuth.get<IPersistKeyResponse>(
    `/v2.0.2/persist/key/seen_search_welcome`
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const postSeenSearchWelcome = async (): Promise<
  IResponseService<any>
> => {
  try {
    const response = await legacyApiAuth.post<any, any>('/v2.0.2/persist', {
      key: 'seen_search_welcome',
      value: true
    })
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getSeenSearchTour = async (): Promise<
  IResponseService<IPersistKeyResponse>
> => {
  const response = await legacyApiAuth.get<IPersistKeyResponse>(
    `/v2.0.2/persist/key/seen_search_tour`
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const postSeenSearchTour = async (): Promise<IResponseService<any>> => {
  try {
    interface IPostSeenSearchTourBody {
      key: string
      value: boolean
    }

    const response = await legacyApiAuth.post<string, IPostSeenSearchTourBody>(
      '/v2.0.2/persist',
      {
        key: 'seen_search_tour',
        value: true
      }
    )
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getAssociations = async (): Promise<
  IResponseService<IGetAssociationsResponse[]>
> => {
  const response = await legacyApiAuth.get<IGetAssociationsResponse[]>(
    `/v2.0.2/user/associations`
  )

  try {
    return {
      isSuccess: true,
      data: response || []
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getPropertyView = async (
  propertyId: string
): Promise<IResponseService<IGenericObject>> => {
  const response = await legacyApiAuth.get<IGenericObject>(
    `/v2.0.2/property/${propertyId}/view?search_from=SEARCH_RESUME`
  )

  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

interface IPostSearchParams {
  [key: string]: any
}

export const saveSearch = async (
  searchValues: IPostSearchParams
): Promise<IResponseService<any>> => {
  try {
    const response = await legacyApiAuth.post<string, IPostSearchParams>(
      '/v2.0.2/properties/save_search_data',
      searchValues
    )
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
export const getPreviousSearch = async (): Promise<
  IResponseService<{ lastSearch: ISearchFilter }>
> => {
  try {
    const response = await legacyApiAuth.get<{ lastSearch: ISearchFilter }>(
      '/v2.0.2/properties/last_search'
    )
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
